import React, {useContext, useRef, useState, useEffect} from "react";
import DataFailureAlert from "~/components/child/tradingViewMainChart/ui/DataFailureAlert";
import Header from "./header/Header";
import { chartSize } from "~/components/child/tradingViewMainChart/utils/helpers/tools/createChartStyles";
import { TVChartContainer } from "~/components/child/tradingViewMainChart/tvChartContainer/imbalances/TVChartContainer";
import {MainChartContext} from "~/components/child/tradingViewMainChart/context/MainChartContext";
import { ToastContainer, toast, Slide } from 'react-toastify';
import { Loading } from "~/components/child/ui/Loading";
import { AlertTriangle } from 'lucide-react'
import LayoutLoading from "~/components/pages/tools/imbalances/layoutLoading";

const Imbalances = () => {
  const chartRef = useRef();

  const [chartIsReady, setChartIsReady] = useState(false);
  const [pair, setPair] = useState("BTC/USDT");
  const [isPlotZones, setIsPlotZones] = useState(false);
  const [error, setError] = useState(false);
  const [dataLoading, setDataLoading] = useState({ zones : false, rotations: false });
  const [imbalanceValue, setImbalanceValue] = useState(99);

  const {
    theme,
    isLoading ,
    favorites: mainChartFavorites,
    setFavorites: setMainChartFavorites,
    isChartDataValid,
    hasFavoriteChartDataChanged
  } = useContext(MainChartContext);

  useEffect(() => {
    if (error) {
      toast.error("Please try again.", {
        theme: "colored",
        icon: <AlertTriangle />,
        className: 'mb-0',
        position: "bottom-left",
        autoClose: 4000,
        rtl: false,
        pauseOnFocusLoss: true,
        transition: Slide,
      });

      const timer = setTimeout(() => {
        setIsPlotZones(false);
        setError(false);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [error]);


  return (
      <div className={`${chartSize?.fullScreen} relative`}>
          {isChartDataValid ? (
              <>

                <ToastContainer/>

                <Header
                    setChartIsReady={setChartIsReady}
                    chartRef={chartRef}
                    pair={pair}
                    setPair={setPair}
                    isPlotZones={isPlotZones}
                    setIsPlotZones={setIsPlotZones}
                    imbalanceValue={imbalanceValue}
                    setImbalanceValue={setImbalanceValue}
                    theme={theme}
                    dataLoading={dataLoading}
                    setError={setError}
                />

                <div className={"h-full"}>
                  {
                      (!chartIsReady || dataLoading?.zones || dataLoading?.rotations) &&
                      <div data-testid="imbalances-loading-overlay">
                        <LayoutLoading/>
                      </div>
                  }

                  <TVChartContainer
                      ref={chartRef}
                      setChartIsReady={setChartIsReady}
                      pair={pair}
                      setIsPlotZones={setIsPlotZones}
                      imbalanceValue={imbalanceValue}
                      theme={theme}
                      mainChartFavorites={mainChartFavorites}
                      setMainChartFavorites={setMainChartFavorites}
                      hasFavoriteChartDataChanged={hasFavoriteChartDataChanged}
                      setDataLoading={setDataLoading}
                      setError={setError}
                  />

                </div>
              </>
          ) : !isLoading ? (
              <div data-testid="imbalances-data-failure" className="h-full flex">
                <DataFailureAlert/>
              </div>

          ) : (
              <div data-testid="imbalances-loading" className="h-full flex">
                <Loading/>
              </div>
          )}
      </div>
  );
};

export default Imbalances;
